module.exports = __webpack_public_path__ + "media/images/gallery/dir_off-f941ecd2c70734d125c102cdabda3330.gif";